import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable } from "rxjs";
import { IRound } from "../interfaces";
import { RoundRepository } from "../round.repository";

@Injectable()
export class GetRoundUseCase implements IUseCase<void, Observable<IRound | undefined>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(): Observable<IRound | undefined> {
        return this.roundRepository.get();
    }
}
